import { animate, style, transition, trigger } from "@angular/animations";
import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "h-grid-page-banner",
    templateUrl: "./grid-page-banner.component.html",
    styleUrls: ["./grid-page-banner.component.scss"],
    animations: [
        trigger("slideDown", [
            transition(":enter", [
                style({ transform: "translateY(-100%)" }),
                animate("900ms ease-in", style({ transform: "translateY(0)" })),
            ]),
        ]),
    ],
})
export class GridPageBannerComponent {
    @Output()
    public closeBannerFacet: EventEmitter<void> = new EventEmitter();
}
